import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../theme.css';
import Footer from './Footer';
import CookieConsent, { Cookies } from "react-cookie-consent";
interface PHomePageFooter {
}

class SHomePageFooter {
	constructor() {
	}
}

class HomePageFooter extends Component<PHomePageFooter, SHomePageFooter> {
	render() {
		return (
			<footer id='footer'>
				<div className='' style={{ backgroundColor: '#009DF5', paddingTop: 50, paddingBottom: 50 }}>
					<div className='col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom-20' style={{ padding: 0 }}>
						<div className='col-lg-3 col-md-3 col-sm-5 col-xs-8' style={{ padding: 20, backgroundColor: '#053359' }}>
							<div className='pull-right'>
								<SVGLogo />
							</div>
						</div>
						{/* <div className='col-lg-4 col-md-4 col-sm-5 col-xs-12 text-center'>
							<div style={{ padding: 30 }}>
								<span style={{ padding: 10, marginRight: 25 }} className='fb'><FacebookSVG /></span>
								<span style={{ padding: 10, marginRight: 25 }} className='twitter'><TwitterSVG /></span>
								<span style={{ padding: 10, marginRight: 25 }} className='linkedin'><LinkedInSVG /></span>
							</div>
						</div> */}
					</div>
					<div className='container font-Gotham-Pro-Medium'>
						<div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
							<div className='col-lg-9 col-lg-offset-3 col-md-9 col-md-offset-3 col-sm-10 col-sm-offset-1 col-xs-12'>
								<div className='col-md-6'>
									<div className='font-size-16 font-Gotham-Pro-Medium' style={{ color: '#FFFFFF', padding: 10 }}><Link to={{ pathname: '/about-us' }} style={{ color: '#FFFFFF' }}>About Us</Link></div>
									<div className='font-size-16 font-Gotham-Pro-Medium' style={{ color: '#FFFFFF', padding: 10 }}><Link to={{ pathname: '/plans-and-pricing' }} style={{ color: '#FFFFFF' }}>Plans And Pricing</Link></div>
									<div className='font-size-16 font-Gotham-Pro-Medium' style={{ color: '#FFFFFF', padding: 10 }}><Link to={{ pathname: '/view-listings' }} style={{ color: '#FFFFFF' }}>Browse</Link></div>
									<div className='font-size-16 font-Gotham-Pro-Medium' style={{ color: '#FFFFFF', padding: 10 }}><Link to={{ pathname: '/create-listings' }} style={{ color: '#FFFFFF' }}>Create</Link></div>
								</div>
								<div className='col-md-6'>
									<div className='font-size-16 font-Gotham-Pro-Medium' style={{ color: '#FFFFFF', padding: 10 }}>Contacts</div>
									<div className='font-size-14' style={{ color: '#FFFFFF', padding: 10 }}>
										<div style={{ paddingTop: 5, paddingBottom: 5 }} className=''>125 S. Clark St.,</div>
										<div style={{ paddingTop: 5, paddingBottom: 5 }} className=''>17th Floor</div>
										<div style={{ paddingTop: 5, paddingBottom: 5 }} className=''>Chicago, IL 60603</div>
										<div style={{ paddingTop: 5, paddingBottom: 5 }} className='font-Gotham-Pro-Medium'>Call: +1 (312) 957-7757</div>
										<div style={{ paddingTop: 5, paddingBottom: 5 }} className='font-Gotham-Pro-Medium'>info@industrialnavigator.com</div>
									</div>
								</div>
								{/* <div className='col-lg-5 col-md-5 col-sm-5 col-xs-12'>
									<div className='font-size-16 font-Gotham-Pro-Medium' style={{ color: '#FFFFFF', padding: 10 }}>Subscribe</div>
									<div className='font-size-16 font-Gotham-Pro-Medium' style={{ color: '#FFFFFF', padding: 10 }}>
										<input type='text' className='form-control margin-bottom-0-imp' placeholder='Email Address'></input>
									</div>
								</div> */}
							</div>
						</div>
					</div>
					<CookieConsent
						location="bottom"
						buttonText="Accept"
						cookieName="myCookie"
						style={{ background: "#053359",opacity: '0.6' ,width:'auto',display:'block',flexWrap:'none' }}
						buttonStyle={{ color: "#fffff",background:'#0094e9', fontSize: "13px",width:'auto' }}
						expires={150}
					>
						<span style={{display:'flex'}} >By clicking Accept you acknowledge and agree to our terms of service and cookie policy.{" "}</span>
						{/* <span style={{ fontSize: "10px" }}>This is the text with small size</span> */}
					</CookieConsent>
				</div>
				<Footer />
			</footer>
		)
	}
}

export default HomePageFooter;

const SVGLogo = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='200'
		height='39'
		viewBox='0 0 200 39'
	>
		<defs>
			<path
				id='path-1'
				d='M0 12.553h6.78v20.339H0v-20.34zm20.339 0h6.78v20.339h-6.78v-20.34zm10.17-6.78h6.78v20.339h-6.78V5.772z'
			></path>
			<path
				id='path-2'
				d='M55.308 15.36V1.111h-3.624V15.36h3.624zm1.955 0h3.495V9.162a1.897 1.897 0 011.896-2.119c1.204 0 1.797.763 1.797 2.034v6.29h3.505v-7.04c0-2.597-1.372-4.137-3.821-4.137a3.39 3.39 0 00-3.407 2.25h-.069V4.379h-3.396v10.99-.009zm16.45.148a3.475 3.475 0 003.357-2.034h.059v1.885h3.485V.4H77.11v5.895h-.068a3.4 3.4 0 00-3.299-2.074c-2.734 0-4.423 2.133-4.423 5.619.003 3.525 1.668 5.668 4.394 5.668zm1.303-8.532c1.303 0 2.113 1.116 2.113 2.893 0 1.778-.81 2.882-2.113 2.882s-2.119-1.096-2.119-2.893c-.004-1.776.816-2.882 2.12-2.882zm18.02-2.607h-3.505v6.201a1.88 1.88 0 01-1.856 2.119c-1.145 0-1.837-.711-1.837-2.044v-6.28h-3.496v7.05a3.814 3.814 0 004.02 4.128 3.13 3.13 0 003.199-2.262h.069v2.074h3.406V4.37zm1.56 3.328c0 1.67 1.136 2.797 3.279 3.249l2.063.435c.879.187 1.215.444 1.215.898 0 .593-.594.947-1.57.947a1.616 1.616 0 01-1.847-1.312H94.34c.148 2.23 2.014 3.683 5.17 3.683 3.05 0 5.104-1.452 5.104-3.713 0-1.66-.928-2.548-3.12-3.012l-2.271-.474c-.848-.178-1.264-.484-1.264-.932 0-.583.583-.968 1.472-.968a1.454 1.454 0 011.688 1.294h3.203c-.02-2.251-1.886-3.664-4.847-3.664-2.993.004-4.878 1.39-4.878 3.57zm12.215-5.756v2.428h-1.472v2.59h1.471v5.391c0 2.153 1.115 3.031 3.94 3.031a7.135 7.135 0 001.54-.138v-2.488a4.81 4.81 0 01-.711.05 1.073 1.073 0 01-1.271-1.156V6.96h1.98V4.372h-1.985V1.943h-3.495l.003-.002zm6.99 13.418h3.496V9.553a2.13 2.13 0 012.33-2.39c.388-.007.773.06 1.136.198V4.359a2.917 2.917 0 00-.899-.138 2.594 2.594 0 00-2.597 2.212h-.069V4.37h-3.396v10.99zm8.078 0h3.505V4.37h-3.505v10.99zm1.747-11.898a1.73 1.73 0 10-1.797-1.728 1.742 1.742 0 001.797 1.728zm8.051 9.618c-.898 0-1.481-.435-1.481-1.136 0-.672.543-1.096 1.54-1.165l2.024-.138v.763a1.875 1.875 0 01-2.086 1.676h.003zm-1.235 2.429a3.688 3.688 0 003.269-1.728h.07v1.58h3.396V7.835c0-2.212-1.949-3.704-4.878-3.704-2.972 0-4.915 1.472-5.006 3.693h3.15a1.54 1.54 0 011.688-1.186 1.395 1.395 0 011.63 1.382v.633l-2.578.158c-2.873.178-4.453 1.313-4.453 3.367-.004 1.976 1.645 3.329 3.709 3.329h.003zm8.541-.149h3.495V.4h-3.495v14.96zM56.814 38.11v-11.5h.109l8.35 11.5h3.937V18.518h-4.727v11.39h-.108l-8.306-11.39h-3.977v19.591h4.724-.002zm27.128 0h5.295l-6.584-19.591h-6.096l-6.585 19.591h5.077l1.25-4.304h6.408l1.235 4.304zm-4.491-15.437h.108l2.172 7.55h-4.466l2.186-7.55zm19.7 15.437l6.246-19.591H99.94l-3.76 14.718h-.109l-3.782-14.718h-5.662l6.246 19.591h6.28zm11.99 0V18.518h-4.983v19.591h4.984zm19.878-8.282v-2.402h-8.39v3.42h3.584l-.014.3c-.135 1.968-1.71 3.298-3.964 3.298-2.865 0-4.711-2.348-4.711-6.231 0-3.814 1.67-6.028 4.491-6.028a3.806 3.806 0 013.87 2.797h4.928c-.503-3.992-4.06-6.802-8.814-6.802-5.92 0-9.558 3.746-9.558 10.1 0 6.436 3.639 10.17 9.68 10.17 5.58 0 8.896-3.27 8.896-8.622h.002zm13.415 8.282h5.295l-6.585-19.591h-6.096l-6.584 19.591h5.078l1.248-4.304h6.408l1.236 4.304zm-4.492-15.437h.109l2.173 7.55h-4.467l2.185-7.55zm17.502 15.437V22.536h5.43v-4.018h-15.847v4.018h5.43V38.11H157.445zm14.542-19.93c-5.932 0-9.68 3.898-9.68 10.141 0 6.244 3.734 10.128 9.68 10.128 5.933 0 9.667-3.882 9.667-10.128 0-6.245-3.741-10.141-9.674-10.141h.007zm0 4.046c2.783 0 4.603 2.361 4.603 6.095 0 3.72-1.82 6.083-4.603 6.083-2.796 0-4.602-2.362-4.602-6.083-.011-3.734 1.81-6.095 4.595-6.095h.007zm15.967.054h2.933a2.703 2.703 0 012.933 2.796 2.627 2.627 0 01-2.919 2.77h-2.947v-5.566zm0 8.974h2.58l3.353 6.856h5.594l-3.91-7.59a5.86 5.86 0 003.34-5.538c0-4.046-2.635-6.463-7.523-6.463h-8.42v19.591h4.981v-6.856h.005z'
			></path>
		</defs>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g transform='translate(-130 -40)'>
				<g transform='translate(130 33)'>
					<g transform='translate(0 7)'>
						<path
							fill='#4DAFFF'
							fillRule='nonzero'
							d='M10.169 5.773H16.949V26.112H10.169z'
						></path>
						<g>
							<use fill='#053359' xlinkHref='#path-1'></use>
							<use fill='#FFF' xlinkHref='#path-1'></use>
						</g>
						<g>
							<use fill='#053359' xlinkHref='#path-2'></use>
							<use fill='#FFF' xlinkHref='#path-2'></use>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

const FacebookSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='10'
		height='19'
		viewBox='0 0 10 19'
	>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g fill='#FFF' transform='translate(-535 -3115)'>
				<g transform='translate(0 2840)'>
					<g transform='translate(530 274)'>
						<path d='M11.25 7.513V5.145c0-.654.56-1.184 1.25-1.184h1.25V1h-2.5C9.179 1 7.5 2.59 7.5 4.553v2.96H5v2.96h2.5v9.475h3.75v-9.474h2.5L15 7.514h-3.75z'></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

const TwitterSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='17'
		viewBox='0 0 20 17'
	>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g fill='#FFF' transform='translate(-590 -3115)'>
				<g transform='translate(0 2840)'>
					<g transform='translate(530 274)'>
						<g transform='translate(60)'>
							<path d='M20 3.013a8.256 8.256 0 01-2.362.677 4.236 4.236 0 001.803-2.37 7.978 7.978 0 01-2.6 1.037A4.026 4.026 0 0013.846 1C11.576 1 9.75 2.928 9.75 5.29c0 .34.027.667.095.979-3.409-.174-6.425-1.883-8.452-4.487a4.472 4.472 0 00-.56 2.168c0 1.486.73 2.803 1.82 3.565A3.913 3.913 0 01.8 6.987v.047c0 2.084 1.421 3.816 3.285 4.214a3.921 3.921 0 01-1.075.142c-.263 0-.528-.016-.776-.074.531 1.7 2.039 2.948 3.831 2.988A8.01 8.01 0 010 16.075 11.177 11.177 0 006.29 18c7.545 0 11.67-6.538 11.67-12.206 0-.19-.006-.373-.015-.554A8.398 8.398 0 0020 3.013z'></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

const LinkedInSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 20 20'
	>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g fill='#FFF'>
				<path d='M15.033 6.312c4.194 0 4.967 2.764 4.967 6.352V20L15.857 20v-6.647c-.004-1.525-.098-3.39-2.155-3.39-2.156 0-2.486 1.684-2.486 3.425v6.611H7.074V6.647h3.978v1.82h.058c.553-1.049 1.906-2.155 3.923-2.155zm-10.556.335V20H.33V6.648h4.147zM2.402 0c1.325 0 2.4 1.076 2.401 2.402 0 1.325-1.075 2.424-2.401 2.424C1.076 4.826 0 3.728 0 2.402A2.402 2.402 0 012.402 0z'></path>
			</g>
		</g>
	</svg>
)